import {Box, IconButton, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import RecommendedSettingDropdown from "./recommended-setting/RecommendedSettingDropdown";
import CreateIcon from "@mui/icons-material/Create";
import {COLORS} from "../../ui/Theme";

const RecommendedForm = () => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
            }}
        >
            {/*SELECT OPTION (DROP DOWN)*/}
            <RecommendedSettingDropdown/>

            {/*EDIT BUTTON*/}
            <Link
                to="setting"
                style={{
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    border: `1px solid ${COLORS.SOFTBLUE}`,
                    borderRadius: "12px",
                    backgroundColor: COLORS.SOFTBLUE,
                    padding: "12px 8px",
                    width: "46px",
                    height: "46px",
                }}
            >
                <IconButton
                    disableRipple
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        padding: "0"
                    }}
                >
                    <CreateIcon sx={{color: COLORS.BLUE, fontSize: "18px"}}/>
                </IconButton>
            </Link>
        </Box>
    );
};

export default RecommendedForm;
